export const PAGES_MAX = 116;
export const PAGES_MIN = 20;
export const TYPE_DECADE = 'DECADE';
export const TYPE_ROOM = 'ROOM';
export const TYPE_ACTIVITY = 'ACTIVITY';
export const TYPE_WELCOME = 'WELCOME';
export const TYPE_THANKS = 'THANKS';